import {getAuthProvider} from '@/providers/authProvider';
import {getDataProvider} from '@/providers/dataProvider';
import {DogList} from '@/routes/dogs';
import {DogEdit} from '@/routes/dogs/dog';
import {UserList} from '@/routes/users';
import {LicenseList} from '@/routes/licenses';
import {LicenseEdit} from '@/routes/licenses/license';
import {LoginPage} from '@/routes/login';
import {ResetPassword} from '@/routes/reset-password';
import {RuleCreate} from '@/routes/rules/ruleCreate';
import {VerifyAccount} from '@/routes/verify-account';
import {adminTheme} from '@/styles/theme';
import {formatUserDisplayName} from '@/utils/formatUserDisplayName';
import DogsIcon from '@mui/icons-material/PetsOutlined';
import PersonIcon from '@mui/icons-material/PersonOutline';
import RuleIcon from '@mui/icons-material/RuleOutlined';
import WalletIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import {useMemo} from 'react';
import {Admin, CustomRoutes, Resource} from 'react-admin';
import {Route, useNavigate} from 'react-router-dom';
import {Layout} from './Layout';
import {UserShow} from '@/routes/users/user.tsx';

export const App = () => {
    const navigate = useNavigate();
    const dataProvider = useMemo(() => getDataProvider(navigate), [navigate]);
    const authProvider = useMemo(() => getAuthProvider(navigate), [navigate]);

    return (
        <Admin
            layout={Layout}
            loginPage={LoginPage}
            dataProvider={dataProvider}
            authProvider={authProvider}
            theme={adminTheme}
        >
            <Resource
                name="licenses"
                icon={WalletIcon}
                list={LicenseList}
                edit={LicenseEdit}
            />
            <Resource
                name="dogs"
                icon={DogsIcon}
                list={DogList}
                edit={DogEdit}
            />
            <Resource
                name="users"
                recordRepresentation={(user) => formatUserDisplayName(user)}
                icon={PersonIcon}
                list={UserList}
                show={UserShow}
            />
            <Resource
                name="rules"
                icon={RuleIcon}
                list={RuleCreate}
                options={{label: 'Breed Rules'}}
                create={RuleCreate}
            />

            {/* --------------------------------------------------------
             *  PUBLIC ROUTES
             *  -------------------------------------------------------- */}

            <CustomRoutes noLayout>
                <Route path="/verify-account" element={<VerifyAccount />} />
                <Route path="/reset-password" element={<ResetPassword />} />
            </CustomRoutes>
        </Admin>
    );
};
